<template>
    <div
        class="loading-skeleton --slim-margin --subheadline loading-badge"
        aria-hidden="true"
    ></div>
    <div
        class="loading-skeleton --slim-margin --headline loading-title"
        aria-hidden="true"
    ></div>
    <div
        class="loading-skeleton --slim-margin --line loading-description"
        aria-hidden="true"
    ></div>
    <div
        class="loading-skeleton --slim-margin --line loading-description --short"
        aria-hidden="true"
    ></div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/basics/loading-skeleton.scss';

    .loading-badge {
        width: 8rem;
    }

    .loading-title {
        max-width: 34rem;
        width: 90%;
    }

    .loading-description {
        max-width: 30rem;
        width: 80%;
    }

    .loading-skeleton.--short {
        width: 55%;
    }

    .loading-media-placeholder {
        aspect-ratio: 1 / 1;
        background: rgba($white, 0.42);
        border-radius: 50%;
        bottom: 0;
        left: 0;
        max-width: none;
        position: relative;
        right: auto;
        transform: translateY(var(--training-hero-media-sink));
        width: 100%;
        z-index: 1;

        @media (min-width: $br-m) {
            left: auto;
            max-width: min(100%, 28rem);
            position: absolute;
            right: 0;
            width: min(100%, 28rem);
        }
    }
</style>
